import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { KNOWN_SUPPLIERS } from '../constants/suppliers';

// Shared "where we order from" supplier list -- facility setting `order_suppliers`
// (Settings.tsx OrderSuppliersCard), a JSON array of plain strings, defaulting to
// KNOWN_SUPPLIERS when the setting is empty/invalid/not yet loaded. This is NOT the vendors
// table (service companies) -- do not confuse the two. Shared query key ['order-suppliers'] so
// Inventory's Add to Order modal and the Orders page's ItemModal read the same cache entry.
export function useOrderSuppliers() {
  const query = useQuery({
    queryKey: ['order-suppliers'],
    queryFn: () => api.get<Record<string, string>>('/settings/facility-settings', { keys: 'order_suppliers' }),
  });
  const suppRaw = (query.data as unknown as { data: Record<string, string> })?.data?.['order_suppliers'];
  let supplierList: string[] = KNOWN_SUPPLIERS;
  try { if (suppRaw) supplierList = JSON.parse(suppRaw); } catch { /* keep default */ }
  return {
    supplierList,
    // true once the settings fetch has resolved (success or not) -- callers that need to
    // distinguish "still loading, defaults are a placeholder" from "loaded, defaults are final"
    // (e.g. AddToOrderModal's fromInit one-time override) can gate on this.
    isLoaded: query.data !== undefined,
  };
}
